import { Text } from "north.js";
import React from "react";

import globalConstants from "src/theme/globalConstants";

import { useRequestActions } from "./hooks";
import RequestGroupComponent from "./RequestGroup";
import { ItemGroupsWrapper, ItemGroup } from "./styles";
import {
  THardwareRequestsHistoryListProps,
  THardwareItemCardProps,
} from "./types";
import { groupItemsByRequest, getStatusDisplayNameForUser } from "./utils";

const HardwareRequestsHistoryList: React.FC<THardwareRequestsHistoryListProps> =
  ({
    hardwareRequests,
    userType,
    onPrintLabel,
    onUpdateStatus,
    onRefresh,
    onReturnSuccess,
    isLoading = false,
    printerEndpoint,
  }) => {
    const {
      printingRequests,
      updatingRequests,
      selectedStatuses,
      handleStatusChange,
    } = useRequestActions();

    return (
      <ItemGroupsWrapper>
        {hardwareRequests.length > 0 ? (
          hardwareRequests.map((itemGroup) => {
            const groupedByRequest = groupItemsByRequest(itemGroup.items);
            return (
              <ItemGroup key={itemGroup.status}>
                <Text type="h2">
                  {getStatusDisplayNameForUser(itemGroup.status, userType)}
                </Text>
                {Object.entries(groupedByRequest).map(([requestId, items]) => (
                  <RequestGroupComponent
                    key={requestId}
                    requestId={requestId}
                    items={items as THardwareItemCardProps[]}
                    requestData={
                      itemGroup.requestDataById?.[parseInt(requestId, 10)]
                    }
                    status={itemGroup.status}
                    userType={userType}
                    onPrintLabel={onPrintLabel}
                    onUpdateStatus={onUpdateStatus}
                    onRefresh={onRefresh}
                    onReturnSuccess={onReturnSuccess}
                    isLoading={isLoading}
                    printerEndpoint={printerEndpoint}
                    printingRequests={printingRequests}
                    updatingRequests={updatingRequests}
                    selectedStatuses={selectedStatuses}
                    onStatusChange={handleStatusChange}
                  />
                ))}
              </ItemGroup>
            );
          })
        ) : (
          <Text
            type="body1"
            style={{ color: globalConstants?.color?.textSecondary as string }}
          >
            No requests found.
          </Text>
        )}
      </ItemGroupsWrapper>
    );
  };

export default HardwareRequestsHistoryList;
